define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const i18n = require('i18n');
    const core = require('core');
    const config = require('config');
    const AddressLookupView = require('common/addressLookup/addressLookupView');

    module.exports = AddressLookupView.extend({

        /**
         * @override
         */
        getCountryCode: function() {
            return 'US';
        },

        /**
         * @override
         */
        setAddressResult: function(result) {
            if (result.length > 1) {
                this.showDropDown(result, this.convertAddressToSearch(result));

                return;
            }

            const { DTAG_UPDATE_DETAILS_STATES = [] } = config.get('dynamicTags');
            const isStateExist = JSON.parse(DTAG_UPDATE_DETAILS_STATES).some(obj => obj.value === result[0].state);

            if (!isStateExist) {
                this.showError(i18n.t('playtech.mobile.registration.addressLookup.address.invalidAddress'));
                this.hideDropDown();

                return;
            }

            this.toggleVisibility(true);

            this.$('.fn-lookup-input-text').val(result[0].label);
            this.$('.fn-lookup-inner').forEach(field => {
                var $visibleInput = $(field).find('input[type="text"],input[type="number"]');
                var $visibleSelect = $(field).find('select');
                var $hiddenInput = $(field).find('input[type="hidden"]');
                var val = result[0][field.dataset.name];

                if (val) {
                    if ($visibleInput.length) {
                        $visibleInput.val(val);
                    }

                    if ($visibleSelect.length) {
                        $visibleSelect.find('option').removeAttr('selected');
                        $visibleSelect.find(`option[value="${val}"]`).attr('selected', true);
                        $visibleSelect.val(val);
                        $visibleSelect.trigger('input').trigger('change');
                    }

                    $hiddenInput.val(val);

                    this.options.form.validateField(field);

                    $visibleInput.attr('disabled', 'disabled').addClass('inner-field-disabled');
                    $visibleSelect.attr('disabled', 'disabled').addClass('inner-field-disabled');
                    $hiddenInput.removeAttr('disabled').removeClass('inner-field-disabled');
                }
            });

            this.hideDropDown();
        },

        /**
         * @override
         */
        reset: function() {
            const { DTAG_DEFAULT_REGISTRATION_STATE } = config.get('dynamicTags');
            const form = this.options.form;

            this.$el.find('.fn-lookup, .fn-lookup-inner').forEach(el => {
                var $field = $(el);

                $field.find('input').forEach(input => {
                    input.value = '';
                    $(input).trigger('input');
                });

                $field.find('select').forEach(select => {
                    $(select).find('option').removeAttr('selected');
                    $(select).trigger('input');
                });

                const $stateSelect = $field.find('select[id="state"]');

                if (DTAG_DEFAULT_REGISTRATION_STATE && $stateSelect) {
                    $stateSelect.find(`option[value="${DTAG_DEFAULT_REGISTRATION_STATE}"]`).attr('selected', true);
                    $stateSelect.val(DTAG_DEFAULT_REGISTRATION_STATE);
                    $stateSelect.trigger('input').trigger('change');
                }

                form.resetField($field);
            });

            this.model.set({
                searchResult: null
            });

            this.toggleVisibility(false);
        },

        /**
         * @override
         */
        prepareRenderOptions: function() {
            const preparedRenderOptions = AddressLookupView.prototype.prepareRenderOptions.call(this);
            const stateField = preparedRenderOptions.innerFields.find(field => field.name === 'state');
            const { DTAG_DEFAULT_REGISTRATION_STATE } = config.get('dynamicTags');

            if (stateField) {
                if (DTAG_DEFAULT_REGISTRATION_STATE) {
                    stateField.state = DTAG_DEFAULT_REGISTRATION_STATE;
                } else {
                    core.error('DTAG_DEFAULT_REGISTRATION_STATE DOSE NOT SETUP');
                }
            }

            return preparedRenderOptions;
        },

         /**
         * @override
         */
         onItemsHide: function() {
            var $inputEl = this.$('.fn-lookup-input-text');

            $inputEl.removeClass('no-validate');

            if (document.activeElement === $inputEl.get(0)) {
                return;
            }

            if ($inputEl.hasClass('prevent-validation')) {
                $inputEl.removeClass('prevent-validation');

                return;
            }

            this.options.form.validateField(this.$('.fn-lookup'), this.options.form.options.data);
        },

         /**
         * @override
         */
        onItemSelect: function(index) {
            var selectedItem = this.model.get('searchResult')[index];

            if (selectedItem.type === 'Address') {
                this.$('.fn-lookup-input-text').addClass('prevent-validation');
            }

            AddressLookupView.prototype.onItemSelect.call(this, index);
        }
    });
});
